import { peopleEmptySurfaceClass } from '../../config/glassSurfaces';

export default function PeopleListEmptyState({ children }) {
  return (
    <div className={peopleEmptySurfaceClass()}>
      <p className="px-4 py-10 text-center text-sm text-gray-500 dark:text-dark-muted glass-surface-subtle-text">
        {children}
      </p>
    </div>
  );
}
